import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import { faWallet } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useWallet from "../../walletconnect/hook";
import {MetamaskConnector} from "../../walletconnect/connectors";
import {initWeb3} from "../../contract_utils/web3_functions";
import config from "../../config.js";

let pathname = window.location.pathname;

if(pathname === "" || pathname === "/") {
  pathname = "/";
}

/*
const chainSeq = [
    {
        id: config.SmartContract_CHANNEL,
        title: config.chain_title,
        chain: config.chain_id,
    }
];
*/

interface WalletConnectProps {
    pathname ?: string
}


export const WalletConnect = (props: WalletConnectProps) => {
    // Wallet logic
    const { active, account, library, connector, activate, deactivate, chainId } = useWallet();

    return (

        <div className="profile">
             <a href="#" onClick={activate}>
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="30.4222" height="24.2" viewBox="0 0 30.4222 24.2"><defs></defs><path className="cls-1" d="M29.3148,10.9174V6.7383c-.0008-.6769-.2664-1.3259-.7385-1.8045-.4722-.4786-1.1123-.7479-1.78-.7487v-1.5319c-.0008-.6769-.2664-1.3258-.7385-1.8045-.4722-.4786-1.1123-.7479-1.78-.7487h-8.0593c-.1336,0-.2518,0-.3562,0-.1043,0-.1475,0-.1475,0H2.6185c-.6677,.0008-1.3078,.2701-1.78,.7487C.3664,1.3274,.1008,1.9763,.1,2.6532V21.5468c-.0003,.3354,.0646,.6675,.191,.9775,.1265,.3099,.312,.5915,.5459,.8286,.2339,.2372,.5117,.4252,.8174,.5534,.3057,.1282,.6334,.194,.9642,.1937H26.7963c.6677-.0008,1.3078-.2701,1.78-.7487,.4721-.4787,.7377-1.1276,.7385-1.8045v-3.6684c.2936-.1053,.548-.2999,.7283-.5573,.1804-.2574,.2778-.565,.2791-.8807v-4.0851c-.0013-.3157-.0987-.6233-.2791-.8807-.1803-.2574-.4347-.452-.7283-.5572ZM2.6185,1.1213H24.2778c.4007,0,.7851,.1614,1.0685,.4487s.4426,.6769,.4426,1.0832v1.5319H2.6185c-.4008,0-.7851-.1614-1.0685-.4487-.2834-.2873-.4426-.6769-.4426-1.0832s.1592-.7959,.4426-1.0832c.2834-.2873,.6677-.4487,1.0685-.4487ZM26.7963,23.0787H2.6185c-.1986,.0004-.3952-.0389-.5788-.1158-.1835-.0768-.3503-.1896-.4907-.332-.1404-.1423-.2517-.3113-.3275-.4974-.0758-.186-.1146-.3854-.1142-.5867V4.6825c.4334,.3379,.9643,.522,1.5111,.5239H26.7963c.4008,0,.7851,.1614,1.0685,.4487,.2834,.2873,.4426,.6769,.4426,1.0832v4.0851h-1.0074v-3.5745c0-.2709-.1061-.5306-.2951-.7222-.1889-.1915-.4451-.2991-.7123-.2991H3.1222c-.1336,0-.2617,.0538-.3562,.1496-.0945,.0958-.1475,.2257-.1475,.3611s.0531,.2653,.1475,.3611c.0945,.0958,.2226,.1496,.3562,.1496H26.2926v3.5745h-2.0148c-.9352,0-1.832,.3766-2.4932,1.0469-.6613,.6704-1.0327,1.5796-1.0327,2.5276s.3714,1.8572,1.0327,2.5275c.6612,.6703,1.558,1.0469,2.4932,1.0469h2.0148v3.0639H3.1222c-.1336,0-.2617,.0538-.3562,.1495-.0945,.0958-.1475,.2257-.1475,.3611s.0531,.2653,.1475,.3611c.0945,.0957,.2226,.1495,.3562,.1495H26.2926c.2672,0,.5234-.1076,.7123-.2991,.189-.1915,.2951-.4513,.2951-.7221v-3.0639h1.0074v3.5745c0,.4063-.1592,.7959-.4426,1.0832-.2834,.2873-.6677,.4487-1.0685,.4487Zm2.5185-6.6383c0,.1355-.0531,.2653-.1475,.3611-.0945,.0958-.2226,.1496-.3562,.1496h-4.5333c-.668,0-1.3086-.269-1.7809-.7478-.4723-.4789-.7376-1.1283-.7376-1.8054s.2653-1.3266,.7376-1.8054c.4723-.4788,1.1129-.7478,1.7809-.7478h4.5333c.1336,0,.2617,.0538,.3562,.1495,.0944,.0958,.1475,.2257,.1475,.3611v4.0851Z"/><path className="cls-1" d="M24.2778,12.866c-.2989,0-.591,.0898-.8395,.2581-.2485,.1684-.4422,.4076-.5566,.6875-.1144,.28-.1443,.588-.086,.8851,.0583,.2972,.2022,.5702,.4136,.7844,.2113,.2142,.4806,.3601,.7737,.4193,.2931,.0591,.597,.0287,.8731-.0872,.2761-.116,.5121-.3123,.6781-.5642,.1661-.252,.2547-.5481,.2547-.8511,0-.4063-.1592-.796-.4426-1.0833-.2834-.2872-.6677-.4486-1.0685-.4486Zm0,2.0425c-.0996,0-.197-.0299-.2798-.086-.0829-.0562-.1474-.1359-.1856-.2292-.0381-.0933-.0481-.196-.0286-.295,.0194-.0991,.0674-.1901,.1378-.2615,.0705-.0714,.1602-.12,.2579-.1398,.0977-.0197,.199-.0095,.2911,.0291,.092,.0387,.1707,.1041,.226,.1881,.0554,.084,.0849,.1827,.0849,.2837,0,.1354-.0531,.2653-.1475,.3611-.0945,.0957-.2226,.1495-.3562,.1495Z"/></svg>
            </a>
            <div className="profile-dropdown">
                <ul className="profile-dropdown-nav">
                    

                    { !active && 
                        <li key="connect">
                            <Link onClick={activate} to={(props.pathname) ? props.pathname: window.location.pathname} >Connect your wallet</Link>
                        </li>
                    }
                    
                    { active && 
                        <li key="connect">
                            <Link onClick={deactivate} to={(props.pathname) ? props.pathname: window.location.pathname} >Disconnect from {config.chain_title}</Link>
                        </li>
                    }
                    
                </ul>
            </div>
        </div>
    ) 
}

export default WalletConnect;
